import { WINDOW } from "../utils/window-utils"
import HotlistStorage from "../decorators/hotlist-storage"
import Utils from "../utils/utilities"

const GET_STARTED: string = '/hotlist'

export default class Routing {

    @HotlistStorage
    private hotlistStore: any

    private static route(url: string): void {
        WINDOW.nativeWindow.location.href = url
    }

    public routeToGetStarted(errorStatus?: number): void {
        if (Utils.isDefined(errorStatus)) Routing.route(`${GET_STARTED}?errored=${errorStatus}`)
        else Routing.route(GET_STARTED)
    }

    public routeToDefaultId(): void {
        Routing.route(`/hotlist/${this.hotlistStore.id}`)
    }

    public routeToId(id: string): void {
        Routing.route(`/hotlist/${id}`)
    }
}